import { render, staticRenderFns } from "./FeedbackThankYou.html?vue&type=template&id=4010e983&scoped=true&external"
import script from "./FeedbackThankYou.vue?vue&type=script&lang=js"
export * from "./FeedbackThankYou.vue?vue&type=script&lang=js"
import style0 from "./FeedbackThankYou.css?vue&type=style&index=0&id=4010e983&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4010e983",
  null
  
)

export default component.exports